import jsPDF from "jspdf";

const generatePDF = (template, data) => {
  const { sections = [] } = template;
  const doc = new jsPDF('p', 'mm', 'a4');
  let yPosition = 20;
  const pageHeight = 297;
  const marginTop = 20;
  const marginBottom = 20;
  const marginLeft = 20;
  const maxWidth = 170;
  const lineHeight = 4;
  const paragraphSpacing = 8;

  const checkPageBreak = (heightNeeded) => {
    if (yPosition + heightNeeded > pageHeight - marginBottom) {
      doc.addPage();
      yPosition = marginTop;
    }
  };

  const addWrappedText = (text, bold = false) => {
    if (bold) {
      doc.setFont("helvetica", "bold");
    } else {
      doc.setFont("helvetica", "normal");
    }
    doc.setFontSize(10);
    const splitText = doc.splitTextToSize(text, maxWidth);
    const lines = splitText.length;
    const heightNeeded = (lines * lineHeight) + paragraphSpacing;
    checkPageBreak(heightNeeded);
    doc.text(splitText, marginLeft, yPosition);
    yPosition += heightNeeded;
  };

  const addSingleLineText = (text, fontSize = 12, bold = false) => {
    if (bold) {
      doc.setFont("helvetica", "bold");
    } else {
      doc.setFont("helvetica", "normal");
    }
    doc.setFontSize(fontSize);
    const heightNeeded = (fontSize / 3) + 5;
    checkPageBreak(heightNeeded);
    doc.text(text, marginLeft, yPosition);
    yPosition += heightNeeded;
  };

  checkPageBreak(30);
  doc.setFontSize(20);
  doc.setFont("helvetica", "bold");
  doc.text("OFFER LETTER", marginLeft, yPosition);
  yPosition += 15;

  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");
  addSingleLineText(`Date: ${data.currentDate}`,10);

  addSingleLineText("To",10);
  addSingleLineText(`Mr. ${data.fullName}`,10);
  addSingleLineText(`${data.presentAddress || "_____________ (residential address)"}`,10);
  addSingleLineText(`Phone No: ${data.workPhoneNumber || "________________________"}`,10);
  yPosition += 5;

  addSingleLineText("Sub:OfferLetter");
  yPosition += 5;

  addSingleLineText(`Dear ${data.fullName},`);
  yPosition += 5;

  sections.forEach((section) => {
    if (section.heading) {
      addSingleLineText(section.heading, 12, true);
    }
    section.paragraphs.forEach((para) => {
      const replaced = para.replace(/\{([^}]+)\}/g, (match, key) => data[key] || match);
      addWrappedText(replaced);
    });
  });

  addSingleLineText("With regards,",10);
  yPosition += 5;
  addSingleLineText(`${data.hrName}`,10);
  yPosition += 2;
  addSingleLineText(`${data.hrMail}`,10);
  yPosition += 2;
  addSingleLineText("HR - Head",10);
  yPosition += 20;

  doc.addPage();
  yPosition = marginTop;

  addWrappedText(
    `I accept the aforesaid terms & conditions and this offer of employment. I shall keep the contents of this document confidential.`,
    true
  );

  doc.setFont("helvetica", "normal");
  addSingleLineText(`I will join on ${data.joinDate}.`);

  addSingleLineText(`Name: ${data.fullName}`);
  addSingleLineText("Signature: _________________");
  addSingleLineText("Date: ______________________");

  doc.save(`OfferLetter_${data.firstName}_${data.lastName}.pdf`);
};

export default generatePDF;
